<template>
  <section :id="section">
      <b-row>
        <template v-for="(item, i) in sections[section]">
          <b-col md="12" :key="item.title+i">
            <h2 v-html="wrapWords(item.title)"></h2>
          </b-col>
          <b-col md="4" :key="item.subtitle+i">
            <h3>{{ item.subtitle }}</h3>
            <figure class="precallout" v-if="item.precallout" v-html="item.precallout"></figure>
            <div class="intro" v-html="item.intro"></div>
          </b-col>
          <b-col md="7" offset-md="1"  :key="i">
            <carousel-3d :ref="section + '-carousel'" v-if="item.slides" :id="section + '-carousel'" :perspective="0" :space="slideSpace" :display="3" :controlsVisible="true" :width="slideWidth" :height="slideHeight">
              <slide :key="item.subtitle+i" v-for="(slide, i) in item.slides" :index="i">
                <div :key="slide.url+i"><div class="embed-responsive embed-responsive-16by9 youtube-player" slot="img" :data-id="youtubeID(slide.url)"></div></div>
              </slide>
            </carousel-3d>
            <div v-if="item.video" class="youtube-player" :data-id="youtubeID(item.video)"></div>
            <figure v-if="item.video" class="callout" v-html="item.callout"></figure>
            <figure v-else v-html="item.callout"></figure>
          </b-col>
        </template>
      </b-row>
  </section>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Carousel',
  data () {
    return {
      sections: this.content.sections,
      slide: 0,
      slideWidth: $('.carousel-3d-container').width() - 150,
      slideHeight: $('.carousel-3d-container').height() - 100,
      slideSpace: 125
    }
  },
  props: ['section'],
  methods: {
    wrapWords: function(str, tmpl) {
      return str.replace(/[^\s\\]+\s|\w+[?=\.]|\w+/g, tmpl || "<span>$&</span>");
    },
    youtubeID: function(url) {
      return url.replace('https://www.youtube.com/watch?v=','');
    },
    onResize: function(event) {
      // this.slideWidth = $('.carousel-3d-container').width() - 150;
      // this.slideHeight = $('.carousel-3d-container').width() * .5265;
      if ($(window).width() > 768) {
        this.slideWidth = $('.carousel-3d-container').width() - 250;
        this.slideHeight = ($('.carousel-3d-container').width() - 250) * .7;
        this.slideSpace = 125;
      } else {
        this.slideWidth = $('.carousel-3d-container').width() - 50;
        this.slideHeight = ($('.carousel-3d-container').width() - 50) * .7;
        this.slideSpace = 125;
      }
    }
  },
  created: function() {
    if ($(window).width() > 768) {
      this.slideWidth = $('.carousel-3d-container').width() - 150;
      this.slideHeight = ($('.carousel-3d-container').width() - 250) * .7;
      this.slideSpace = 125;
    } else {
      this.slideWidth = $('.carousel-3d-container').width() - 50;
      this.slideHeight = ($('.carousel-3d-container').width() - 50) * .7;
      this.slideSpace = 125;
    }
    var vThis = this;
    $(document).ready(function() {
      var section = vThis.$el.id+'-carousel';
      if (undefined !== vThis.$refs[section] && vThis.$refs[section].length > 0) {
        $('body').on('click', '.indicator', function () {
          var section = $(this).closest('.carousel-3d-container').attr('id');

          if (undefined !== vThis.$refs[section]) {
            vThis.$refs[section][0].goSlide($(this).data('index'));
          }
          $(this).parent().children('.indicator').removeClass('active');
          $(this).addClass('active');
        });
      }
    });
  },
  mounted: function() {
    var vThis = this;
    window.addEventListener('resize', this.onResize);
    window.addEventListener('load', this.onResize);
    if ($(window).width() > 768) {
      this.slideWidth = $('.carousel-3d-container').width() - 150;
      this.slideHeight = ($('.carousel-3d-container').width() - 250) * .7;
      this.slideSpace = 125;
    } else {
      this.slideWidth = $('.carousel-3d-container').width() - 50;
      this.slideHeight = ($('.carousel-3d-container').width() - 50) * .7;
      this.slideSpace = 125;
    }

    $(document).ready(function() {
      $('.next, .prev').on('click',function(){
        $('.youtube-player iframe').each(function(){
          $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        });
        if ($(this).closest('.carousel-3d-container').hasClass('video-loaded')) {
          $(this).closest('.carousel-3d-container').removeClass('video-loaded');
        }
        $(this).closest('.carousel-3d-container').find('.indicator').removeClass('active');
      });
      $('.prev').on('click',function(){
        var active = 0;
        $($(this).closest('.carousel-3d-container').find('.carousel-3d-slide')).each(function(i) {
          if ($(this).hasClass('current')) {
            active = i;
          }
        });
        if (active == 0) {
          active = 4
        }
        $(this).closest('.carousel-3d-container').find('.indicator[data-index="' + (active-1) +'"]').addClass('active');
      });
      $('.next').on('click',function(){
        var active = 0;
        $($(this).closest('.carousel-3d-container').find('.carousel-3d-slide')).each(function(i) {
          if ($(this).hasClass('current')) {
            active = i;
          }
        });
        if (active == 3) {
          active = -1
        }
        $(this).closest('.carousel-3d-container').find('.indicator[data-index="' + (active+1) +'"]').addClass('active');
      });
      $('iframe').on('click', function() {
        $(this).closest('.carousel-3d-container').addClass("video-loaded");
      });
      $('.carousel-3d-container').each(function() {
        var indicators = '';
        var count = $(this).children().children('.carousel-3d-slide').length;
        for (var i = 0; i < count; i++) {
          if (i == 0) {
            indicators += '<li class="indicator active" data-index="' + i +'"></li>';
          } else {
            indicators += '<li class="indicator" data-index="' + i +'"></li>';
          }
        }
        if ($(this).children('ul.indicators').length == 0) {
          $(this).append('<ul class="indicators">' + indicators + '</ul>');
        }
      });
    });
  },
  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResize)
  }
}

document.addEventListener("DOMContentLoaded", function() {
    var div, n,
        v = document.getElementsByClassName("youtube-player");
    for (n = 0; n < v.length; n++) {
        div = document.createElement("div");
        div.setAttribute("data-id", v[n].dataset.id);
        div.setAttribute("class", "thumbnail");
        div.innerHTML = labnolThumb(v[n].dataset.id);
        div.onclick = labnolIframe;
        v[n].appendChild(div);
    }
});

function labnolThumb(id) {
    var thumb = '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg">',
        play = '<div class="play"></div>';
    return thumb.replace("ID", id) + play;
}

function labnolIframe() {
    var iframe = document.createElement("iframe");
    var embed = "https://www.youtube.com/embed/ID?autoplay=1&enablejsapi=1&version=3&playerapiid=ytplayer";
    iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowscriptaccess","always");
    iframe.setAttribute("allowfullscreen", "1");
    $(this).closest('.carousel-3d-container').addClass("video-loaded");
    this.parentNode.replaceChild(iframe, this);
}
</script>

<style lang="scss" scoped>
@import '../_variables.scss';

.col-md-12 {
  @media (min-width: 768px) {
    text-align: center;
    padding: 4rem 0 2rem;
  }
}
h3 {
  font-family: $runda;
  font-size: 24px;
  margin-bottom: 1rem;
  margin-top: 2rem;
  font-weight: normal;
  font-style: normal;
}
.intro {
  margin-bottom: 3rem;
}
figure {
  font-family: $runda;
  font-size: 24px;
  line-height: 1.25;
  font-weight: 700;
  text-align: center;
  margin: 3rem 0;
  @media (min-width: 768px) {
    margin: -1rem 0 3rem;
    &.precallout {
      margin: 3rem 0 3rem;
    }
    &.callout {
      margin: 1rem 0 3rem;
    }
  }
}
.carousel.slide {
  padding-bottom: 3rem;
}
.carousel-3d-slide {
  background: none;
  border: none;
  height: auto !important;
}
.carousel-3d-container {
  margin-left: -30px;
  margin-right: -30px;
  width: calc(100% + 60px);
  overflow: visible;
  @media (min-width: 768px) {
    overflow: hidden;
    padding-bottom: 51%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue